import React, { Component } from "react";
import themeLarge from "../ThemeLarge";

class PublishModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tagInput: "",
      filteredSuggestions: [],
    };
  }

  render() {
    const {
      slug,
      excerpt,
      coverPhoto,
      isPublishing,
      onExcerptChange,
      onCoverPhotoUpload,
      onConfirm,
      tags,
      onTagsChange,
    } = this.props;

    return (
      <div
        className="modal fade"
        id="publishModal"
        tabIndex="-1"
        aria-labelledby="publishModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="publishModalLabel">
                Confirm Publish
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="slug">Edit Slug</label>
                <input
                  type="text"
                  className="form-control"
                  id="slug"
                  value={slug}
                  disabled
                />
              </div>

              <div className="form-group">
                <label htmlFor="excerpt">Edit Excerpt</label>
                <textarea
                  className="form-control"
                  id="excerpt"
                  rows="3"
                  value={excerpt}
                  onChange={onExcerptChange}
                ></textarea>
              </div>

              {/* tag */}
              <div className="form-group mt-3">
                <label htmlFor="tags">Tags (min 1, max 5)</label>
                <input
                  type="text"
                  className="form-control"
                  id="tags"
                  placeholder="Type to search or add tags"
                  value={this.state.tagInput}
                  onChange={(e) => {
                    const input = e.target.value.toLowerCase();
                    const filtered = (this.props.tagSuggestions || []).filter(
                      (tag) =>
                        tag.startsWith(input) &&
                        !this.props.tags.includes(tag.toLowerCase())
                    );
                    this.setState({
                      tagInput: input,
                      filteredSuggestions: filtered,
                    });
                  }}
                  onKeyDown={(e) => {
                    if (
                      (e.key === "Enter" || e.key === ",") &&
                      this.state.tagInput
                    ) {
                      e.preventDefault();
                      this.props.onTagsChange(this.state.tagInput);
                      this.setState({ tagInput: "", filteredSuggestions: [] });
                    }
                  }}
                />

                {/* Suggestion Dropdown */}
                {this.state.filteredSuggestions.length > 0 && (
                  <div className="border rounded p-2 mt-1 bg-light">
                    {this.state.filteredSuggestions.map((tag, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          this.props.onTagsChange(tag);
                          this.setState({
                            tagInput: "",
                            filteredSuggestions: [],
                          });
                        }}
                        style={{ cursor: "pointer", padding: "2px 6px" }}
                      >
                        {tag}
                      </div>
                    ))}
                  </div>
                )}

                {/* Show selected tags */}
                <div className="mt-2 d-flex flex-wrap gap-2">
                  {this.props.tags.map((tag, i) => (
                    <span
                      key={i}
                      className="badge px-3 py-2"
                      style={{
                        fontSize: "0.9rem",
                        background: themeLarge.colors.primary,
                        color: themeLarge.colors.secondary,
                        paddingLeft: "5px",
                        borderRadius: "15px",
                      }}
                    >
                      {tag}
                      <button
                        type="button"
                        className="btn-close btn-close-white btn-sm ms-2"
                        onClick={() => this.props.onRemoveTag(i)}
                      />
                    </span>
                  ))}
                </div>

                {/* Validation message */}
                {this.props.tags.length < 1 && (
                  <div className="text-danger mt-1">
                    At least one tag is required.
                  </div>
                )}
              </div>

              <div className="form-group mt-3">
                <label htmlFor="coverPhoto">
                  Upload Cover Photo (landscape only)
                </label>
                <input
                  type="file"
                  className="form-control"
                  id="coverPhoto"
                  accept="image/*"
                  onChange={onCoverPhotoUpload}
                />
              </div>

              {!coverPhoto && (
                <div className="text-danger mt-2">
                  Cover photo is required to publish.
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={onConfirm}
                disabled={isPublishing || !coverPhoto}
              >
                {isPublishing ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    &nbsp; Publishing...
                  </>
                ) : (
                  "Confirm Publish"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PublishModal;
